import {useEditPermissions} from '@github-ui/code-view-shared/contexts/EditPermissionsContext'
import {usePath} from '@github-ui/code-view-shared/contexts/PathContext'
import {useRefInfo} from '@github-ui/code-view-shared/contexts/RefInfoContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {repositoryTreePath} from '@github-ui/paths'
import {Link} from '@github-ui/react-core/link'
import {ActionList} from '@primer/react'
import {Text} from '@primer/styled-react'

export function DeleteDirectoryItem() {
  const repo = useCurrentRepository()
  const path = usePath()
  const refInfo = useRefInfo()
  const {canEdit} = useEditPermissions()

  if (!canEdit) {
    return null
  }
  return (
    <ActionList.LinkItem
      as={Link}
      to={repositoryTreePath({repo, path, commitish: refInfo.name, action: 'tree/delete'})}
    >
      <Text sx={{color: 'danger.fg'}}>Delete directory</Text>
    </ActionList.LinkItem>
  )
}
